import { useCurrentUser } from '../useCurrentUser/useCurrentUser';

export const useUserRole = () => {
  const { data: user } = useCurrentUser();

  if (!user) {
    return null;
  }

  return user?.is_superuser ? 'admin' : 'user';
};
